import { useId } from 'react';
import { cn } from '@/lib/utils';
import { Checkbox } from '@/components/ui/checkbox';
import { ISoftwareUsed } from '@/redux/post/post.d';
import SoftwareLogo from './SoftwareLogo';

export default function SoftwareChip({
  value,
  active,
  onToggle,
}: {
  value: ISoftwareUsed;
  active: boolean;
  onToggle: () => void;
}) {
  const id = useId();
  return (
    <label
      htmlFor={id}
      className={cn(
        'flex cursor-pointer items-center gap-2.5 rounded-lg border px-3 py-2.5 text-left text-sm font-medium transition-colors duration-fast',
        active
          ? 'border-primary bg-accent'
          : 'border-input bg-background hover:bg-muted'
      )}
    >
      <SoftwareLogo name={value} />
      <span className="min-w-0 flex-1 truncate">{value}</span>
      <Checkbox
        id={id}
        aria-label={value}
        checked={active}
        onCheckedChange={onToggle}
        className="flex-none"
      />
    </label>
  );
}
